module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/009d2bdb612e58522ac2847ed3be2ad9.png";